export default __webpack_public_path__ + "static/media/gallery_01.06c0b1ad.jpg";